import React from "react";

import { Box, BoxProps, Typography } from "@material-ui/core";
import { APIError } from "../../components/APIError";
import { ExtendedContainer } from "../../components/ExtendedContainer";
import { PropertyLoader } from "./components/PropertyLoader";
import { PropertiesList } from "./PropertiesList";
import { useAccountProperties } from "../../api/hooks/useAccountProperties";

interface PropertiesContainerProps extends Partial<BoxProps> {
  accountNumber: string;
}

export const PropertiesContainer: React.FC<PropertiesContainerProps> = ({
  accountNumber,
  ...props
}) => {
  const { status, data, error } = useAccountProperties(accountNumber);

  const properties = data?.results;
  const numProperties = data?.results.length;

  return (
    <ExtendedContainer px={0} py={0} maxWidth="none" {...props}>
      <Box mb={1.5}>
        <Typography
          variant="overline"
          data-testid="PropertiesContainer__Heading"
        >
          Properties
          {typeof numProperties !== "undefined" ? ` (${numProperties})` : null}
        </Typography>
      </Box>

      {error ? (
        <Box display="flex" justifyContent="flex-start">
          <APIError
            title="We could not load the properties for this account."
            messages={[(error as Error).message]}
          />
        </Box>
      ) : status === "loading" ? (
        <PropertyLoader data-testid="PropertiesContainer__Loader" />
      ) : properties ? (
        <PropertiesList properties={properties} />
      ) : null}
    </ExtendedContainer>
  );
};
